// @flow
import {pathOr} from 'ramda';

import type {ActionType} from 'constants/flow/flowTypes';

import type {ICmsBlock, ICmsItem} from './cmsBlockType';
import {CATEGORY} from 'constants/actions';

const initialState = {
    status: 'initial',
    collection: {},
};

/**
 * Get cms block by ID
 * @param {ICmsBlock} state Current state
 * @param {ActionType} action Received action
 * @returns {{}} state New state
 */
export default function cmsBlock(
    state: ICmsBlock = initialState,
    action: ActionType<ICmsItem, {bannerName: string}>,
): {} {
    switch (action.type) {
        case 'GET_CMS_BLOCK_BY_ID_FULFILLED':
            return {
                collection: {
                    ...state.collection,
                    [pathOr(action.payload.data.identifier, ['meta', 'bannerName'], action)]: action
                        .payload.data,
                },
                status: 'fulfilled',
            };
        case 'GET_CMS_BLOCK_BY_ID_PENDING':
            return {...state, status: 'pending'};
        case 'GET_CMS_BLOCK_BY_ID_REJECTED':
            return {...state, ...{status: 'rejected'}};
        case CATEGORY.CLEAR_CATEGORY_DATA:
            return initialState;
        default:
            return state;
    }
}
